type ErrorBannerProps = {
  message: string;
  onDismiss: () => void;
};

export const ErrorBanner = ({ message, onDismiss }: ErrorBannerProps) => {
  return (
    <div className="banner banner--error" role="alert">
      <span>{message}</span>
      <button type="button" className="btn btn--ghost" onClick={onDismiss}>
        Закрыть
      </button>
    </div>
  );
};
